import React ,{useState} from 'react'
import { Modal } from "reactstrap";
import PropTypes from "prop-types"
import { toast } from "react-toastify";

function DeleteModal(props) {
    const [loading, setLoading] = useState(false)

    const handleDeletedItem = async () => {
        setLoading(true)
        const { data: response } = await props.modelService.removeMany({unit_ids :props.ids});
        toast.success(response.success)
        return props.onCloseModal('delete', response)
    }
    return (
        <Modal isOpen={props.open}   >
            <div className="modal-header border-0">
                <h5 className="modal-title mt-0" id="myModalLabel">
                    <i className='fa fa-trash'/> Delete Units
                </h5>
                <button
                    type="button"
                    onClick={() => props.onCloseModal('close')}
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body border-0">
                <p>
                    {`Kindly note that this action can't be undone and the ${props.titleMsg} details will get deleted.`}
                </p>
            </div>
            <div className="modal-footer border-0">
                <button
                    type="button"
                    onClick={() => props.onCloseModal('close')}
                    className="btn me-auto btn-secondary waves-effect waves-light"
                    data-dismiss="modal"
                >
                    Cancel
            </button>
                <button
                    onClick={handleDeletedItem}
                    type="button"
                    className="btn btn-success waves-effect"
                    disabled={loading ? true : false}

                >
                    Delete
            </button>
            </div>
        </Modal>
    )
}

DeleteModal.propTypes = {
    open: PropTypes.bool,
    onCloseModal: PropTypes.func,
    handleTableChange: PropTypes.func,
    deletedItem: PropTypes.object,
    modelService: PropTypes.object,
    titleMsg: PropTypes.string
};

export default DeleteModal
